
import Log from "./pages/Log";
import './App.css';
import './styles/apple-theme.css';

function App() {
    return (
        <div className="App-body">
            <Log />
        </div>
    );
}

export default App;
